// Knee Injury Template Configuration

export const kneeTemplate = {
  id: 'KNEE',
  name: 'Knee',
  icon: 'ðŸ¦µ',
  dominantSide: 'leg',

  fields: {
    injuredSide: {
      type: 'radio',
      label: 'Which knee is injured?',
      options: ['Right', 'Left', 'Both'],
      required: true
    },

    injuryDate: {
      type: 'date',
      label: 'When did you injure your knee?',
      required: true
    },

    injuryDescription: {
      type: 'textarea',
      label: 'Describe how the injury occurred:',
      placeholder: 'What happened when you injured your knee?',
      rows: 3,
      required: true
    },

    mechanism: {
      type: 'checkbox-multiple',
      label: 'How did you injure your knee?',
      options: [
        'Twisting',
        'Got hit directly on the knee',
        'Knee bent backwards too far',
        'Landing from a jump',
        'Changing direction quickly',
        'It came on gradually (no specific injury)',
        'Other'
      ]
    },

    mechanismOther: {
      type: 'text',
      label: 'Please describe what happened:',
      placeholder: 'Tell us how you were injured',
      showWhen: { field: 'mechanism', includes: 'Other' }
    },

    hearPop: {
      type: 'radio',
      label: 'Did you hear or feel a pop/snap at the time of injury?',
      options: ['Yes', 'No']
    },

    continueActivity: {
      type: 'radio',
      label: 'Were you able to continue your activity immediately after?',
      options: ['Yes', 'No']
    },

    swellingOnset: {
      type: 'radio',
      label: 'When did your knee start to swell?',
      options: ['Straight away (within 2 hours)', 'The next day', 'It didn\'t swell']
    },

    painLocation: {
      type: 'text',
      label: 'Where is the pain located?',
      placeholder: 'e.g., Inside of knee, outside, front, back, behind kneecap'
    },

    painSeverity: {
      type: 'radio',
      label: 'How bad is your pain? (0 = no pain, 10 = worst pain ever)',
      options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
    },

    painWorsening: {
      type: 'checkbox-multiple',
      label: 'What makes your pain worse?',
      options: [
        'Walking',
        'Running',
        'Going up stairs',
        'Going down stairs',
        'Squatting',
        'Kneeling',
        'Twisting',
        'Standing up from a chair',
        'Sitting for a long time',
        'Other'
      ],
      hasOtherOption: true
    },

    painWorseningOther: {
      type: 'text',
      label: 'Other (please specify):',
      placeholder: 'Describe other activities that make the pain worse',
      showWhen: { field: 'painWorsening', includes: 'Other' }
    },

    painRelieving: {
      type: 'checkbox-multiple',
      label: 'What makes your pain better?',
      options: [
        'Rest',
        'Ice',
        'Heat',
        'Putting your leg up',
        'Pain medication (like paracetamol)',
        'Anti-inflammatory medication (like ibuprofen)',
        'Knee brace or support',
        'Other'
      ],
      hasOtherOption: true
    },

    painRelievingOther: {
      type: 'text',
      label: 'Other (please specify):',
      placeholder: 'Describe other things that make the pain better',
      showWhen: { field: 'painRelieving', includes: 'Other' }
    },

    locking: {
      type: 'radio',
      label: 'Does your knee ever get stuck and you can\'t straighten or bend it?',
      options: ['Yes', 'No']
    },

    lockingDescription: {
      type: 'textarea',
      label: 'Tell us more about when your knee gets stuck:',
      placeholder: 'How often does it happen? What position is it in? Can you get it unstuck yourself?',
      rows: 2
    },

    clicking: {
      type: 'radio',
      label: 'Does your knee click, pop, or make noises?',
      options: ['Yes', 'No']
    },

    givingWay: {
      type: 'radio',
      label: 'Does your knee give way or feel like it might collapse?',
      options: ['Yes', 'No']
    },

    givingWayFrequency: {
      type: 'text',
      label: 'How often does your knee give way?',
      placeholder: 'e.g., Every day, once a week, only when playing sport'
    },

    swellingCurrent: {
      type: 'radio',
      label: 'Do you currently have swelling?',
      options: ['Yes', 'No']
    },

    walkingDistance: {
      type: 'text',
      label: 'How far can you walk before your knee pain makes you stop?',
      placeholder: 'e.g., 100 metres, 1 kilometre, as far as I want'
    },

    stairsAbility: {
      type: 'radio',
      label: 'How do you manage stairs?',
      options: ['No problem', 'One step at a time', 'With difficulty', 'I can\'t do stairs']
    },

    runningAbility: {
      type: 'radio',
      label: 'Can you run?',
      options: ['Yes, no problem', 'Yes, but it hurts', 'Only short distances', 'I can\'t run']
    },

    sportSpecific: {
      type: 'textarea',
      label: 'How does your knee affect your sport or activities?',
      placeholder: 'What movements or activities can\'t you do because of your knee?',
      rows: 2
    },

    hadPhysio: {
      type: 'radio',
      label: 'Have you had physiotherapy for this injury?',
      options: ['Yes', 'No']
    },

    physioWhere: {
      type: 'text',
      label: 'Where did you have physiotherapy?',
      placeholder: 'e.g., PhysioFirst Hamilton, ACC Physio Clinic',
      showWhen: { field: 'hadPhysio', includes: 'Yes' }
    },

    physioWho: {
      type: 'text',
      label: 'Who was your physiotherapist?',
      placeholder: 'e.g., John Smith, Sarah Jones',
      showWhen: { field: 'hadPhysio', includes: 'Yes' }
    },

    physioWhat: {
      type: 'textarea',
      label: 'What treatment did they provide?',
      placeholder: 'e.g., Exercises, massage, dry needling, ultrasound',
      rows: 2,
      showWhen: { field: 'hadPhysio', includes: 'Yes' }
    },

    physioHelped: {
      type: 'radio',
      label: 'Did the physiotherapy help?',
      options: ['Yes, significantly', 'Yes, somewhat', 'No improvement', 'Made it worse'],
      showWhen: { field: 'hadPhysio', includes: 'Yes' }
    },

    medications: {
      type: 'textarea',
      label: 'What medications have you tried?',
      placeholder: 'e.g., Paracetamol, ibuprofen, voltaren - did they help?',
      rows: 2
    },

    imaging: {
      type: 'radio',
      label: 'Have you had any imaging (X-ray, MRI, ultrasound)?',
      options: ['Yes', 'No']
    },

    imagingType: {
      type: 'checkbox-multiple',
      label: 'What type of imaging have you had?',
      options: ['X-ray', 'MRI', 'Ultrasound', 'CT scan', 'Other'],
      showWhen: { field: 'imaging', includes: 'Yes' }
    },

    imagingWhere: {
      type: 'text',
      label: 'Where was the imaging done?',
      placeholder: 'e.g., Waikato Hospital, Pacific Radiology',
      showWhen: { field: 'imaging', includes: 'Yes' }
    },

    imagingWhen: {
      type: 'date',
      label: 'When was the imaging done?',
      showWhen: { field: 'imaging', includes: 'Yes' }
    },

    imagingResults: {
      type: 'textarea',
      label: 'What were the results?',
      placeholder: 'e.g., Normal, showed meniscal tear, mild arthritis',
      rows: 2,
      showWhen: { field: 'imaging', includes: 'Yes' }
    },

    previousKneeInjuries: {
      type: 'textarea',
      label: 'Have you injured this knee before?',
      placeholder: 'Any previous injuries, operations, or ongoing problems with this knee?',
      rows: 2
    },

    otherKneeHistory: {
      type: 'textarea',
      label: 'Any problems with your other knee?',
      placeholder: 'Tell us about any issues with your other knee',
      rows: 2
    },

    medicalHistory: {
      type: 'textarea',
      label: 'Do you have any other health conditions?',
      placeholder: 'e.g., Arthritis, diabetes, previous operations',
      rows: 2
    },

    currentMedications: {
      type: 'textarea',
      label: 'What medications do you take?',
      placeholder: 'List all the medications you currently take',
      rows: 2
    },

    allergies: {
      type: 'text',
      label: 'Do you have any allergies?',
      placeholder: 'Any allergies to medications or anything else'
    },

    occupation: {
      type: 'text',
      label: 'What is your job?',
      placeholder: 'Your job and how your knee injury affects it'
    },

    sport: {
      type: 'text',
      label: 'What sports or activities do you do?',
      placeholder: 'Tell us about your sports and how active you are'
    },

    smoking: {
      type: 'radio',
      label: 'Do you smoke?',
      options: ['No, never smoked', 'I used to smoke', 'Yes, I smoke']
    }
  },

  sections: [
    {
      id: 'consent',
      title: '0. Consent & Agreements',
      component: 'ConsentSection',
      enabled: true
    },
    {
      id: 'demographics',
      title: '1. Your Details',
      component: 'DemographicsSection',
      enabled: true
    },
    {
      id: 'injury',
      title: '2. How You Injured Your Knee',
      component: 'GenericSection',
      enabled: true,
      fields: ['injuryDate', 'injuredSide', 'mechanism', 'mechanismOther', 'injuryDescription']
    },
    {
      id: 'immediate',
      title: '3. What Happened Straight After',
      component: 'GenericSection',
      enabled: true,
      fields: ['hearPop', 'continueActivity', 'swellingOnset']
    },
    {
      id: 'pain',
      title: '4. Your Pain',
      component: 'GenericSection',
      enabled: true,
      fields: ['painLocation', 'painSeverity', 'painWorsening', 'painWorseningOther', 'painRelieving', 'painRelievingOther']
    },
    {
      id: 'mechanical',
      title: '5. How Your Knee Feels',
      component: 'GenericSection',
      enabled: true,
      fields: ['locking', 'lockingDescription', 'clicking', 'givingWay', 'givingWayFrequency', 'swellingCurrent']
    },
    {
      id: 'functional',
      title: '6. What You Can and Can\'t Do',
      component: 'GenericSection',
      enabled: true,
      fields: ['walkingDistance', 'stairsAbility', 'runningAbility', 'sportSpecific']
    },
    {
      id: 'treatment',
      title: '7. Treatment So Far',
      component: 'GenericSection',
      enabled: true,
      fields: ['hadPhysio', 'physioWhere', 'physioWho', 'physioWhat', 'physioHelped', 'medications', 'imaging', 'imagingType', 'imagingWhere', 'imagingWhen', 'imagingResults']
    },
    {
      id: 'history',
      title: '8. Your Knee History',
      component: 'GenericSection',
      enabled: true,
      fields: ['previousKneeInjuries', 'otherKneeHistory']
    },
    {
      id: 'medical',
      title: '9. Your Health & Lifestyle',
      component: 'GenericSection',
      enabled: true,
      fields: ['medicalHistory', 'currentMedications', 'allergies', 'occupation', 'sport', 'smoking']
    },
    {
      id: 'exercise',
      title: '10. Exercise as a Vital Sign',
      component: 'ExerciseVitalSignSection',
      enabled: true
    },
    {
      id: 'goals',
      title: '11. Your Goals',
      component: 'GoalsSection',
      enabled: true
    }
  ],

  letterTemplate: {
    mechanismLanguage: {
      'Twisting': 'a twisting injury',
      'Got hit directly on the knee': 'a direct blow to the knee',
      'Knee bent backwards too far': 'hyperextension',
      'Landing from a jump': 'landing from a jump',
      'Changing direction quickly': 'cutting/pivoting movement',
      'It came on gradually (no specific injury)': 'gradual onset with no specific event'
    },

    commonDiagnoses: [
      'ACL tear',
      'Meniscal tear (medial or lateral)',
      'MCL sprain',
      'LCL sprain',
      'Patellofemoral pain syndrome',
      'Patellar tendinopathy',
      'Osteoarthritis',
      'Chondromalacia patellae'
    ]
  }
};

export default kneeTemplate;
